import { FC } from 'react'
import clsx from 'clsx'
import PdMedia from '@/components/pd-media/pd-media'
import Image from 'next/image'
import useScrollScale from '@/hooks/tools/use-scroll-scale'

const TagItem: FC<{
  title?: string
  desc?: string
  icon?: string
}> = ({ title, desc, icon }) => {
  return (
    <div className={clsx('flex flex-col gap-1', 'laptop:gap-2')}>
      <div className={clsx('text-28 font-bold flex', 'laptop:text-48', 'flex items-center', 'text-fc-primary')}>
        <span style={{ fontFamily: 'Montserrat' }}>{title}</span>
        {icon && (
          <div className={clsx('relative', 'w-6 h-6 laptop:w-12 laptop:h-12')}>
            <Image src={icon} alt={desc} layout="fill" />
          </div>
        )}
      </div>
      <p className={clsx('text-14', 'laptop:text-16', 'text-fc-secondary')}>{desc}</p>
    </div>
  )
}

type Section5Type = {
  title: string
  desc: string
  tagGroup?: Array<{ title: string; desc: string }>
  mediaUrl: string
  theme?: string
}
const Section5: FC<Section5Type> = ({ theme, title, desc, tagGroup = [], mediaUrl }) => {
  const containerRef = useScrollScale({
    targetSelector: '.target-section5',
  })

  return (
    <div className={clsx('w-full h-fit', 'py-15 laptop:py-30', `pd-theme-${theme}`, 'bg-anti-blk')}>
      <div className={clsx('')}>
        {(title || desc || (tagGroup && tagGroup?.length > 0)) && (
          <div className={clsx('mb-8 max-w-300 mx-auto laptop:mb-64px', 'px-6 laptop:px-0')}>
            {/* title */}
            {title && (
              <h2
                className={clsx(
                  'font-semibold',
                  'mb-3 laptop:mb-6',
                  'laptop:text-center',
                  'whitespace-pre-wrap break-words',
                  'text-fc-primary pd-first-title'
                )}
              >
                {title}
              </h2>
            )}
            <div className={clsx('flex flex-col')}>
              <div className={clsx('flex flex-col-reverse gap-y-8 laptop:flex-row laptop:items-center')}>
                {tagGroup.length > 0 &&
                  tagGroup.map((item) => {
                    return <TagItem key={item.title} {...item} />
                  })}
                {desc && (
                  <p
                    className={clsx(
                      'laptop:w-180 mx-auto',
                      'whitespace-pre-wrap break-words',
                      'text-fc-secondary pd-main-text'
                    )}
                  >
                    {desc}
                  </p>
                )}
              </div>
            </div>
          </div>
        )}

        <div className="w-full laptop:max-w-300 mx-auto">
          <div
            className={clsx(`w-full h-250px laptop:h-fit overflow-hidden`)}
            style={{ aspectRatio: '2/1' }}
            ref={containerRef}
          >
            <PdMedia src={mediaUrl || ''} mask={false} className={`target-section5 scale-150`} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Section5
